import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TeamMember } from '@approot/models/account-info';
import { ConfigService } from '@approot/services';
import { AdminService } from '@approot/services/admin/admin.service';
import { StrategiesService } from '@approot/services/strategies/strategies.service';

@Component({
  selector: 'app-share-strategy-modal',
  templateUrl: './share-strategy-modal.component.html',
  styleUrls: ['./share-strategy-modal.component.scss']
})
export class ShareStrategyModalComponent implements OnInit {
  @Input() isModalOpened = false;
  @Output() shareStrategyOpenChanged = new EventEmitter<boolean>();
  @Output() strategyShared = new EventEmitter<{
    name: string;
    selectedMember: TeamMember;
    message: string;
  }>();
  form: FormGroup;
  columns = ['select', 'email'];
  selectedTeamMembers: any[];
  recipient: TeamMember;
  public enableMessages: boolean;

  constructor(
    private adminService: AdminService,
    private strategiesService: StrategiesService,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.configService.getUserSettings().subscribe(async config => {
      this.enableMessages = !config.parent.disableStrategyMessages;
      this.createShareForm();
    });
  }
  createShareForm() {
    const group: any = {};
    group['recipients'] = new FormControl('', Validators.required);
    group['strategy-name'] = new FormControl('', Validators.required);
    if (this.enableMessages) {
      group['message'] = new FormControl('');
    }

    this.form = new FormGroup(group);
  }

  setRecipient(usr: TeamMember) {
    this.recipient = usr;
  }

  get teamMembers(): TeamMember[] {
    return this.adminService.teamMembers;
  }

  close() {
    this.modalChanged(false);
  }

  modalChanged(event) {
    this.shareStrategyOpenChanged.emit(event);
  }

  onSubmit() {
    let sharingDetails = {
      name: this.form.get('strategy-name').value,
      selectedMember: this.recipient,
      message: this.enableMessages ? this.form.get('message').value : undefined
    };
    this.strategyShared.emit(sharingDetails);
  }

  get savingInfo(): string {
    return this.strategiesService.savingInfo;
  }
}
